module.exports = __webpack_public_path__ + "media/images/icons/misc-5cf8575f5222b132ab1d97ba855cea63.svg";